module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C191"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "C198"
  }, [_vm._v("To Theresa May, my thanks for instigating this project, and to Casey Kittrell, my gratitude for shepherding it to life. For their early reading of the sonnets, I am grateful to Cola Franzen and David Anderson. For their care, expertise, and unfailing good humor in the preparation of the manuscript, I thank Veronica Jorgensen and Rachel Kelleher.")]), _vm._v(" "), _c('p', {
    staticClass: "C199"
  }, [_vm._v("MARGUERITE FEITLOWITZ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13afcc92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowle.vue
// module id = 72
// module chunks = 0